<template>
  <div style="margin: 0px 20px;">
    <el-row>
      <el-col :span="24" >

        <div class="dw-table">
          <div class="dw-table-title">
            <el-row :span="24" type="flex" justify="space-between" align="middle">
              <el-col :span="12"><h3>问卷访问日志记录（未归档的日志）</h3></el-col>
              <el-col :span="12" style="text-align: right;">
                <el-tooltip effect="dark" content="归档答卷日志" placement="top">
                  <el-button size="medium" @click="updateAnswerLogData">归档答卷日志</el-button>
                </el-tooltip>
              </el-col>
            </el-row>
          </div>
          <el-table
            :data="tableData"
            stripe
            style="width: 100%">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column label="IP" width="80" >
              <template slot-scope="scope">
                <div>{{scope.row.ip}}</div>
              </template>
            </el-table-column>
            <el-table-column label="问卷ID" width="280" >
              <template slot-scope="scope">
                <span>{{ scope.row.surveyId }}</span>
              </template>
            </el-table-column>
            <el-table-column label="userAgent" >
              <template slot-scope="scope">
                <span>{{ scope.row.userAgent }}</span>
              </template>
            </el-table-column>
            <el-table-column label="创建时间" width="180" >
              <template slot-scope="scope">
                <span>{{ scope.row.createDate }}</span>
              </template>
            </el-table-column>
          </el-table>
          <div class="dw-pagination">
            <el-pagination
              :page-size="pageSize"
              :current-page="currentPage"
              :total="total"
              background
              layout="total, sizes, prev, pager, next, jumper"
              @current-change="handleCurrentChange"
            >
            </el-pagination>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>

import {
  dwAdminSurveyAnaswerLogList,
  dwSurveyAnswerLogStatsUpdateAll
} from '../../../../api/dw-admin/dw-admin-survey/dw-admin-survey'

export default {
  name: 'DwAdminSurveyAnswerLogList',
  data () {
    return {
      tableData: [],
      pageSize: 10,
      currentPage: 1,
      total: 0
    }
  },
  mounted () {
    this.formInline = {surveyName: null, surveyState: null}
    this.queryList(1)
  },
  methods: {
    buttonClickA (href) {
      window.location.href = href
    },
    handlePush: function (to) {
      this.$router.push(to)
    },
    handleCurrentChange (val) {
      this.queryList(val)
    },
    queryList (pageNo) {
      const params = {
        pageSize: this.pageSize,
        current: pageNo
      }
      dwAdminSurveyAnaswerLogList(params).then((response) => {
        const resultData = response.data.data
        this.tableData = resultData
        this.total = response.data.total
        this.currentPage = response.data.current
        this.pageSize = response.data.pageSize
      })
    },
    updateAnswerLogData () {
      const params = {}
      dwSurveyAnswerLogStatsUpdateAll(params).then((response) => {
        const httpResult = response.data
        if (httpResult.resultCode === 200) {
          this.$message.success('归档任务已经提交，完成后将释放日志存储空间。')
        } else {
          this.$message.error('操作失败')
        }
      })
    }
  }
}
</script>
<style scoped>
.dw-table-form{
  background-color: white;
  padding: 20px;
  margin-bottom: 20px;
}
.dw-table{
  background: white;
  padding: 20px;
}
.dw-table .dw-table-title{
  padding-bottom: 20px;
  border-bottom: 1px solid #f3f3f3;
}
.dw-table .dw-table-title h3{
  padding: 0px;
  margin: 0px;
}
.el-form-item{
  margin-bottom: 0px;
}
.dw-pagination{
  padding-top: 20px;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/views/dw-admin/admin-survey/answer-log/DwAdminSurveyAnswerLogList.vue